import { Component, h, Prop, Fragment } from '@stencil/core';

@Component({
  tag: 'lilu-product-list-teaser',
  styleUrl: 'lilu-product-list-teaser.scss',
  shadow: true,
})
export class LiluProductListTeaser {
  @Prop() linktext = '';
  @Prop() linkurl = '';
  @Prop() heading = '';
  @Prop() subtitle = '';
  @Prop() textcolor = 'white';

  render() {
    const content = (
      <Fragment>
        <slot name="image"></slot>
        <div class="text">
          <lilu-heading color={`${this.textcolor}`} level="2" class="heading">
            {this.heading}
          </lilu-heading>
          {this.subtitle && (
            <lilu-heading color={`${this.textcolor}`} level="3" class="subtitle">
              {this.subtitle}
            </lilu-heading>
          )}
        </div>
      </Fragment>
    );

    return (
      <div class="product-list-teaser">
        {this.linkurl ? (
          <lilu-link link={this.linkurl} type="teaser">
            {content}
          </lilu-link>
        ) : (
          <Fragment>
            {content}
          </Fragment>
        )}
      </div>
    );
  }
}
